<div class="no-results-message">
    <svg-image name="share" class="icon"></svg-image>
    <div class="main" trans>Shared with me.</div>
    <div class="secondary" trans>Files and folders other people have shared with you.</div>
</div>
